import { render, staticRenderFns } from "./SourceEditFormFields.vue?vue&type=template&id=0ae42d36&scoped=true"
import script from "./SourceEditFormFields.vue?vue&type=script&lang=js"
export * from "./SourceEditFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae42d36",
  null
  
)

export default component.exports